import axios from '../../../app/axios';
import type { components } from '../../../shared/api/swagger';

/**
 * Wire-level response shape pulled from `src/shared/api/swagger.d.ts`
 * (regenerate with `npm run gen:types`; source defaults to
 * https://preprod-portalservice.hellohealth.com/v3/api-docs and can be
 * overridden via the SWAGGER_URL env var).
 *
 * Endpoint mapping:
 *   GET /api/practice/unLinkPatient  →  opId: unlinkPatient  →  APIResponseString
 *
 * Note: swagger types this as `APIResponseString`; the runtime payload follows
 * the standard `{ totalCount, success, list, data, responseMsg, responseCode }`
 * envelope captured by `UnlinkPatientResponse` below. We cast at the boundary.
 */

export interface UnlinkPatientRequest {
  userId: number;
  portalAccountId: number;
}

export interface UnlinkPatientResponse {
  totalCount: number;
  success: boolean;
  /** Backend returns null on this endpoint; kept as `unknown` for forward-compat. */
  list: unknown;
  /** Backend returns null on this endpoint; kept as `unknown` for forward-compat. */
  data: unknown;
  responseMsg: string | null;
  responseCode: string | null;
}

export const unlinkPatientApi = async (
  userId: number,
  portalAccountId: number
): Promise<UnlinkPatientResponse> => {
  try {
    const response = await axios.get<components['schemas']['APIResponseString']>(
      '/practice/unLinkPatient',
      { params: { userId, portalAccountId } }
    );

    return response.data as unknown as UnlinkPatientResponse;
  } catch (error) {
    console.error('Error unlinking patient:', error);
    throw error;
  }
};

export const unlinkPatient = async (
  userId: number,
  portalAccountId: number
): Promise<UnlinkPatientResponse> => {
  try {
    const response = await unlinkPatientApi(userId, portalAccountId);

    if (!response.success) {
      throw new Error('Failed to unlink patient');
    }

    return response;
  } catch (error) {
    console.error('Error unlinking patient:', error);
    throw error;
  }
};
